
import MescrollVue from 'mescroll.js/mescroll.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Picker from 'vux/src/components/picker/index.vue'

import {handlealarm, queryhisalarm} from '../../api/device'

export default {
name: 'alarmNew',
components: {
Picker,
MescrollVue 
},
directives: {
TransferDom
},
data () {
return {
years1: [],
year4: [],
changeTime: [],
pickerShow: false,
yearMonth: '',
start: '',
end: '',
alarmData: [],
cnt: 10,
page: 1,
mescrollUp: { // 上拉加载的配置.
callback: this.upCallback,
isBoth: true,
dataList: [] 
},
alarmToast: false,
alarmItem: {},
content: '',
alarmHandle: false,
alarmid: '',
imgArr: []
}
},
created () {
this.imgArr = this.common.getAlamImg()
this.alarmHandle = this.$store.getters.get_alarm_handle
this.alarmid = this.$store.getters.get_alarm_id
let years = []
let year1 = new Date().getFullYear()
for (let i = 2014; i <= year1; i++) {
years.push({
name: i + '年',
value: i + ''
})
}
this.years1 = [years, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]]
let year = new Date().getFullYear()
let month = new Date().getMonth() + 1

this.year4 = [year + '', month + '']
this.changeTime = [year + '', month + '']

this.yearMonth = year + '年' + month + '月'
this.getStartEnd()
},
methods: {
getShowVal (item) {
let show = false
if (item.subdid === 0) { // 主机
if (item.device !== null) {
if (item.device.dtype === 503 || item.device.dtype === 504 || item.device.dtype === 753) {
item.configJson = this.parseConfig(item)
show = true
}
}
} else { // 子机
if (item.childdevice !== null) {
if (item.childdevice.dtype === 2 ||
item.childdevice.dtype === 12 ||
item.childdevice.dtype === 13 ||
item.childdevice.dtype === 52 ||
item.childdevice.dtype === 11 ||
item.childdevice.dtype === 14) {
show = true
}
}
}
return show
},
parseConfig (alarmItem) {
let config = {}
if (alarmItem.config) {
if (alarmItem.device.dtype === 753) {
alarmItem.config.forEach(obj => {
if (obj.m.indexOf('temperature') !== -1) {
if (obj.m === 'temperature' || obj.m === 'temperature1') {
config.temperature = obj.v
} else if (obj.m === 'temperature2') {
config.temperature2 = obj.v
} else if (obj.m === 'temperature3') {
config.temperature3 = obj.v
} else if (obj.m === 'temperature4') {
config.temperature4 = obj.v
}

} else if (obj.m.indexOf('humidity') !== -1) {
if (obj.m === 'humidity' || obj.m === 'humidity1') {
config.humidity = obj.v
} else if (obj.m === 'humidity2') {
config.humidity2 = obj.v
} else if (obj.m === 'humidity3') {
config.humidity3 = obj.v
} else if (obj.m === 'humidity4') {
config.humidity4 = obj.v
}

}
})
}
}
return config
},
getOpenTime () {


this.year4 = this.changeTime
this.pickerShow = true
},
sendTime () {

this.changeTime = [this.year4[0], this.year4[1]]
this.yearMonth = this.changeTime[0] + '年' + this.changeTime[1] + '月'
this.getStartEnd()
this.pickerShow = false
setTimeout(() => {
let page = {num: 1, size: 10}
this.upCallback(page)
}, 100)
},
change (value) {

},
getStartEnd () {

let year = new Date().getFullYear() + ''
let month = new Date().getMonth() + 1 + ''
let day = new Date().getDate() + ''
let endMonth = this.changeTime[1].length === 1 ? '0' + this.changeTime[1] : this.changeTime[1]
let endDay = this.getDay(this.changeTime[0], this.changeTime[1])
if (this.changeTime[0] === year && this.changeTime[1] === month) {
let today = day.length === 1 ? '0' + day : day
this.start = this.changeTime[0] + '-' + endMonth + '-01'
this.end = this.common.GetDateStr(1, this.changeTime[0] + '-' + endMonth + '-' + today)
} else {
this.start = this.changeTime[0] + '-' + endMonth + '-01'
this.end = this.common.GetDateStr(1, this.changeTime[0] + '-' + endMonth + '-' + endDay)
}
},
getDay (year, month) {
let day31 = ['1', '3', '5', '7', '8', '10', '12']
let day30 = ['4', '6', '9', '11']
let day = ''
if (day31.indexOf(month) > -1) {
day = '31'
} else if (day30.indexOf(month) > -1) {
day = '30'
} else {

if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
day = '29'
} else {
day = '28'
}
}
return day
},

mescrollInit (mescroll) {
this.mescroll = mescroll 
},
upCallback (page, mescroll) {
let data = {
cnt: parseInt(this.cnt),
page: parseInt(page.num),
dids: [],
start: this.start,
end: this.end
}
this.alarmHandle = this.$store.getters.get_alarm_handle
this.alarmid = this.$store.getters.get_alarm_id
queryhisalarm(data).then(res => {
if (res.code === 200) {
if (res.data) {
let data = res.data
for (let i = 0; i < data.length; i++) {
if (data[i].config !== '' && typeof data[i].config === 'string') {
let config = JSON.parse(data[i].config)
while (typeof config === 'string') {
config = JSON.parse(config)
}
data[i].config = config
}
}
if (page.num === 1) {
this.alarmData = data
} else {
this.alarmData = this.alarmData.concat(data)
}
if (this.alarmHandle) {
for (let i = 0; i < this.alarmData.length; i++) {
if (parseInt(this.alarmid) === parseInt(this.alarmData[i].id)) {

this.handleAlarm(this.alarmData[i])
}
}
}
}
} else {
}
let vm = this
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(this.alarmData.length)
}, 100)
})
}).catch(() => {
let vm = this
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(0)
}, 100)
})
})
},

getImg (item) {

let dtype1 = parseInt(item.device.dtype)
let img = ''
if (item.childdevice === null) {
for (let i = 0; i < this.imgArr.length; i++) {
if (dtype1 === this.imgArr[i].dtype) {
img = this.imgArr[i].imgUrl
}
}
} else {
for (let i = 0; i < this.imgArr.length; i++) {
if (parseInt(item.childdevice.dtype) === this.imgArr[i].dtype) {
img = this.imgArr[i].imgUrl
}
}
}
if (img === '') {
return this.imgArr[this.imgArr.length - 1].imgUrl
} else {
return img
}
},
getDname (item) {
console.log(item)
if (item.childdevice !== null) {
let sub = item.childdevice.name
if (item.childdevice.setname !== '') {
sub = item.childdevice.setname
}
return item.device.name + '/' + sub
} else if (item.device) {
return item.device.name
} else {
return '未知设备'
}
},

getAlarmType (atype) {
return this.common.getAlarmType(atype)
},

getMPaName (pressure) {
return pressure / 1000000
},

getLevelName (level) {
return level / 100
},

getDeviceProbe (item, type) {
let result = ''
let result1 = ''
let result2 = ''
if (type === 'probe1') {
result1 = item.configJson.temperature ? item.configJson.temperature + '℃' : '--'
result2 = item.configJson.humidity ? item.configJson.humidity + '%' : '--'
result = result1 + ' / ' + result2
} else if (type === 'probe2') {
result1 = item.configJson.temperature2 ? item.configJson.temperature2 + '℃' : '--'
result2 = item.configJson.humidity2 ? item.configJson.humidity2 + '%' : '--'
result = result1 + ' / ' + result2
} else if (type === 'probe3') {
result = item.configJson.temperature3 ? item.configJson.temperature3 + '℃' : '--'
} else if (type === 'probe4') {
result = item.configJson.temperature4 ? item.configJson.temperature4 + '℃' : '--'
}

return result
},

handleAlarm (item) {
console.log(item)

if (item.config !== '' && typeof item.config === 'string') {
let config = JSON.parse(item.config)
while (typeof config === 'string') {
config = JSON.parse(config)
}
item.config = config
}
this.alarmItem = item
this.alarmItem.dname = ''
this.content = ''
this.aid = item.id
if (item.subdid !== 0) {
this.did = item.childdevice.id
this.alarmItem.dname = this.alarmItem.device.name + '/' + this.alarmItem.childdevice.name
} else {
this.did = item.device.id
this.alarmItem.dname = this.alarmItem.device.name
}
this.alarmToast = true
},
closeHandle () {
this.$store.commit('set_alarm_handle', false)
this.$store.commit('set_alarm_id', '')
this.content = ''
this.alarmItem = {}
this.alarmToast = false
},

handleAlarmCommit () {
this.$store.commit('set_alarm_handle', false)
if (this.content === '') {
this.contentMsg = true
} else {
let body = {}
if (parseInt(this.content) === 1) {
body = {
did: this.did,
aid: this.aid,
content: '已处理'
}
} else if (parseInt(this.content) === 2) {
body = {
did: this.did,
aid: this.aid,
content: '误报'
}
}
handlealarm(body).then(res => {
this.alarmToast = false

if (res.code === 200) {
this.$toast('成功')
let page = {num: 1, size: 10}
this.upCallback(page)
}
}).catch(() => {})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/alarm/alarmNew.vue